import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../apis/apis";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

const PAGE_IDS = {
  "terms-and-conditions": 1,
  "privacy-policy": 2,
  "tds-declaration": 3,
  insurance: 4,
  "ride-guidelines": 5,
  "load-unload": 6,
};
const TermsAndConditions = () => {
  const { page } = useParams();
  const [terms, setTerms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTerms = async () => {
      const id = PAGE_IDS[page];

      if (!id) {
        setError("Invalid Page");
        setLoading(false);
        return;
      }

      try {
        const response = await axios.post(
          BASE_URL + "generic/get-terms-condition",
          {
            id: [id], // Replace with relevant IDs or dynamic fetching
          }
        );
        if (response.data.status === 1) {
          setTerms(response.data.data);
        } else {
          setError("No terms and conditions found");
        }
      } catch (err) {
        setError("Failed to fetch terms and conditions");
      } finally {
        setLoading(false);
      }
    };
    fetchTerms();
  }, [page]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // optional
    });
  }, [page]);

  // if (loading)
  //   return (
  //     <div className="text-center py-10 inter font-semibold">Loading...</div>
  //   );
  // if (error)
  //   return <div className="text-center text-red-500 py-10">{error}</div>;

  return (
    <>
      <Navbar />
      <div className="max-w-4xl mx-auto p-6 my-8 bg-white shadow-[0px_0px_10px_rgba(0,0,0,0.15)] rounded-lg inter">
        {terms.map((term) => (
          <div key={term.id} className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
              {term.title}
            </h2>
            <div
              className="prose prose-lg text-gray-700"
              dangerouslySetInnerHTML={{ __html: term.content }}
            ></div>
          </div>
        ))}
      </div>
      <Footer />
    </>
  );
};

export default TermsAndConditions;
